






























































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

export default Vue.extend({
	name: 'FindLeagueDialog',
	props: {
		selectedLeagues: Array,
		step: Number,
		manOfTheMatch: Object,
	},
	data: () => ({
		loading: false,
		dialog: false,
		searchField: '',
		creatingMiniLeague: false,
		miniLeagueParents: [] as any[],
		headers: [
			{ text: 'leagueType', value: 'leagueType', align: 'start' },
			{ text: 'Name', value: 'name' },
			{ text: 'Venue', value: 'venue' },
			{ text: 'Format', value: 'format' },
			{ text: 'dayOfWeek', value: 'dayOfWeek' },
			{ text: 'numberOfTeams', value: 'numberOfTeams' },
			{ text: 'resultsNeeded', value: 'resultsNeeded' },
			{ text: 'displayName', value: 'display_name' },
		],
		filters: {
			country: '',
			cities: [] as string[],
			locations: [] as string[],
			playerType: 'all' as 'all' | 'mens' | 'womens' | 'students' | 'company and friends' | 'coed',
			sortBy: 'A-Z',
			isPlanned: true,
			isActive: true,
			isFinished: false,
		},

		parentLeagues: [],

		errorMessage: '',
	}),
	computed: {
		...mapGetters(['leagues', 'countries', 'cities', 'locations']),

		countryFilterOptions() {
			const countries = [...this.countries];
			return [{ name: 'All', id: null }, ...this.countries];
		},

		cityFilterOptions() {
			return this.cities.filter((c: HasuraCity) => c.country_id === this.filters.country);
		},

		venueFilterOptions() {
			return this.locations.filter((l: HasuraLocation) => this.filters.cities.includes(l.city_id));
		},

		formatFilterOptions() {
			return ['all', 'mens', 'womens', 'students', 'company and friends', 'coed'];
		},

		sortByOptions() {
			return ['Date ASC', 'Date DESC', 'A-Z', 'Created'];
		},

		filteredLeagues() {
			return (
				this.leagues
					// Filter by Country
					.filter((league: any) => {
						if (this.selectedLeagues.includes(league.id)) return false;
						const re = new RegExp(this.searchField, 'i');
						const searchMatch = re.test(league.display_name);
						// Return true if no country is selected or selected country is same as leagues country
						const isCorrectCountry = !this.filters.country || league.locationObj.city.country.id === this.filters.country;
						// Return true if no city is selected or selected city is same as leagues city
						const isCorrectCity = !this.filters.cities.length || this.filters.cities.includes(league.locationObj.city.id);
						// Return true if no locations is selected or selected locations is same as leagues locations
						const isCorrectLocation = !this.filters.locations.length || this.filters.locations.includes(league.location);
						// Return true if no player type is selected or selected player type is same as leagues player type
						const isCorrectPlayerType = this.filters.playerType === 'all' || league.player_type === this.filters.playerType;
						// Return true if status filter matches league's status
						const isCorrectStatus =
							(this.filters.isPlanned && league.status === 'planned') ||
							(this.filters.isActive && league.status === 'active') ||
							(this.filters.isFinished && league.status === 'finished');
						// Return true unless setting up a mini-league and this league is a mini-league
						// let showMiniLeagues = true;
						// if (this.type === 'mini-league' && league.league_type === 'mini-league') {
						// 	showMiniLeagues = false;
						// }
						// return searchMatch && isCorrectCountry && isCorrectCity && isCorrectLocation && isCorrectPlayerType && isCorrectStatus && showMiniLeagues;
						return searchMatch && isCorrectCountry && isCorrectCity && isCorrectLocation && isCorrectPlayerType && isCorrectStatus;
					})
					.sort((a: HasuraLeague, b: HasuraLeague) => {
						// Sort leagues by kick-off date descending
						if (this.filters.sortBy === 'Date DESC') return new Date(b.kick_off_date).getTime() - new Date(a.kick_off_date).getTime();

						// Sort leagues by kick-off date ascending
						if (this.filters.sortBy === 'Date ASC') return new Date(a.kick_off_date).getTime() - new Date(b.kick_off_date).getTime();

						// Sort leagues by kick-off date ascending
						if (this.filters.sortBy === 'A-Z') {
							const aName = a.display_name.toLowerCase();
							const bName = b.display_name.toLowerCase();
							if (aName < bName) return -1;
							if (aName > bName) return 1;
							return 0;
						}

						// Sort leagues by creation date
						if (this.filters.sortBy === 'Created') {
							if (!a.created_at || !b.created_at) return 1;
							return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
						} else return 1;
					})
			);
		},
	},

	methods: {
		cancel() {
			this.parentLeagues = [];
			this.dialog = false;
		},
		async nextStep() {
			if (!this.parentLeagues.length) {
				this.errorMessage = 'Please select one or more parent leagues';
				return;
			}
			this.loading = true;
			const joins =
				this.parentLeagues &&
				this.parentLeagues.map((pl: any) => {
					return {
						league: pl,
						man_of_the_match: this.manOfTheMatch.id,
					};
				});
			console.log('ins', joins);
			try {
				await this.$store.dispatch('insertLeagueManOfTheMatchJoin', joins);
				this.dialog = false;
				this.parentLeagues = [];
				this.$emit('leagueAdded');
			} catch (error) {
				alert('Something went wrong');
			} finally {
				this.loading = false;
			}
		},

		filterChange(val: string) {
			if (val === 'city') {
				this.filters.locations = [];
				this.filters.playerType = 'all';
			}
		},

		handleClick(league: LeagueTableRow) {
			this.errorMessage = '';
			const parentLeagues = [...this.parentLeagues] as any[];
			if (parentLeagues.includes(league.id)) {
				const index = parentLeagues.findIndex(id => id === league.id);
				parentLeagues.splice(index, 1);
				(this as any).parentLeagues = parentLeagues;
			} else {
				parentLeagues.push(league.id);
				(this as any).parentLeagues = parentLeagues;
			}
		},
	},

	filters: {
		day(val: number) {
			if (val === 1) return 'Monday';
			if (val === 2) return 'Tuesday';
			if (val === 3) return 'Wednesday';
			if (val === 4) return 'Thursday';
			if (val === 5) return 'Friday';
			if (val === 6) return 'Saturday';
			return 'Sunday';
		},

		dateToYear(val: string) {
			return dayjs(val).format('MMM YYYY');
		},

		shortenString(val: string) {
			return `${val.slice(0, 45)}...`;
		},
	},

	mounted() {
		this.$store.commit('setBreadcrumb', {
			root: `Step ${this.step}`,
			path: 'Select Parent Leagues',
		});
		// TODO: Change this depending on home country of LM user
		this.filters.country = (this as any).countryFilterOptions[0].id;
	},
});
